import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

// note – these are not error messages, but error codes
export enum EditorPlatformEditActionsErrorCode {
  EditActionPanelUrlFormatIsNotSupported = 'Edit action panel URL format is not supported',
  EditActionExecutionTypeIsNotSupported = 'Edit action execution type is not supported',
  EditActionDataItemKeyIsMissing = 'Edit action data item key is missing',
  EditActionStyleItemKeyIsMissing = 'Edit action style item key is missing',
  EditActionExecutionIsInvalid = 'Edit action execution is invalid',
  EditActionGroupKeyIsMissing = 'Edit action group key is missing',
  EditActionGroupTypeIsMissing = 'Edit action group type is missing',
  EditActionGroupTypeIsNotSupported = 'Edit action group type is not supported',
  EditActionExecutionDoesNotMatchCustomActionFormat = 'Edit action execution does not match custom action format',
  EditActionAppDataIsMissing = 'Edit action app data is missing',
  EditActionUnsupportedActionType = 'Edit action unsupported action type',
  EditActionPanelContentMissing = 'Edit action panel content is missing. The panel might not be loaded because of an error',
  EditActionPanelUrlIsMissing = 'Edit action panel URL is missing',
  EditActionExecutionMethodNotFound = 'Edit action execution method not found',
  EditActionForwardParamsAreMissing = 'Edit action forward parameters are missing',
  EditActionForwardActionNotFound = 'Edit action forward action not found',
  EditActionForwardNotSupported = 'Edit action forward is not supported',
  EditActionForwardElementPathStrategyNotFound = 'Edit action forward element path strategy not found',
  EditActionForwardToSameAction = 'Edit action cannot forward to the same action and element',
  EditActionForwardUnknownAction = 'Edit action forward unknown action',
  EditActionDataIsMissing = 'Edit action data is missing',
}

class EditorPlatformEditActionsError extends BaseError<EditorPlatformEditActionsErrorCode> {
  constructor(message: string, code: EditorPlatformEditActionsErrorCode) {
    super(message, code, 'Editor Platform Edit Actions Error');
  }

  withActionName(actionName: string) {
    this.state.actionName = actionName;
    return this;
  }
}

export const createEditorPlatformEditActionsError = createErrorBuilder<
  EditorPlatformEditActionsErrorCode,
  EditorPlatformEditActionsError
>(EditorPlatformEditActionsError);
